import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import EmailNotificationsSection from './components/EmailNotifications'

import styles from './styles.module.scss'

import { AppDispatch } from '@/store'
import { fetchAllUsersThunk, selectMembers } from '@/store/features/member/memberSlice'
import { selectCurrentEnterprise, selectPlanType, selectUser } from '@/store/features/user/userSlice'
import { PlanType } from '@/types'
import { calculateTrialDays } from '@/utils/dates'
import { isMemberOnTrial } from '@/utils/subscription'

const PersonalSettings = () => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector(selectUser)
  const members = useSelector(selectMembers)
  const enterprise = useSelector(selectCurrentEnterprise)
  const currentPlanType = useSelector(selectPlanType) ?? PlanType.Pro

  useEffect(() => {
    dispatch(fetchAllUsersThunk())
  }, [dispatch])

  const myselfAsMember = useMemo(
    () => members.find((member) => member.userId === user?.userId),
    [members, user?.userId]
  )

  const seat =
    !enterprise || !myselfAsMember
      ? 'Not on a team'
      : myselfAsMember.teamTrialGiven && isMemberOnTrial(myselfAsMember.trialEndsAt)
        ? `${currentPlanType} Trial — ${calculateTrialDays(myselfAsMember.trialEndsAt || 0)} days remaining`
        : `${currentPlanType} Plan`

  return (
    <div className={styles.settingList}>
      <div className={styles.settingSection}>
        <div className={styles.settingInfo}>
          <div className={styles.settingTitle}>Your information</div>
        </div>
        <div className={styles.settingsItem}>
          <div className={styles.toggleLabel}>Your name</div>
          <div className={styles.staticValue}>{user.name || '—'}</div>
        </div>
        <div className={styles.settingsItem}>
          <div className={styles.toggleLabel}>Email</div>
          <div className={styles.staticValue}>{user.email || '—'}</div>
        </div>
        <div className={styles.settingsItem}>
          <div className={styles.toggleLabel}>Your seat</div>
          <div className={styles.staticValue}>{seat}</div>
        </div>
        <EmailNotificationsSection />
      </div>
    </div>
  )
}

export default PersonalSettings
